export const templates_en = {
  'pick_template' : 'Pick a template or create your own',
  'informationmeeting' : 'Information meeting',
  'create_agenda' : 'Create your own agenda',
  'agenda_template' : 'Agenda template',
  'content' : 'Content',
  'choose_template' : 'Choose template',

  'one_description' : 'A 1:1 is the coworkers time with their leader. This is an opportunity for the coworker to share what is top-of-mind right now, and for the leader to offer eventual support or help. The template is a simple structure for how such a meeting could start, but can be edited to suit your needs.',
  'one_headline_1' : "The leader's 3",
  'one_point_1_1' : 'How are you?',
  'one_point_1_2' : 'Anything you would like to talk about today?',
  'one_point_1_3' : 'Anything you need support/help with?',
  'one_headline_2' : "Coworker's 3",
  'one_point_2_1' : 'Subject 1',
  'one_point_2_2' : 'Subject 2',
  'one_point_2_3' : 'Subject 3',

  'fifty_description' : 'A walk for two where the time is split equal to give both parts the opportunity to share without being interrupted. One person listens while the other talks. Set an alarm and change roles after half the time.',
  'fifty_headline_1' : 'Introduction',
  'fifty_point_1_1' : 'Decide who starts',
  'fifty_point_1_2' : 'Do you have a specific subject to discuss or is the discussion open?',
  'fifty_point_1_3' : 'Where are you walking and how much time do you have?',
  'fifty_point_1_4' : 'Set a timer for half the time',
  'fifty_headline_2' : 'Part 1: The first person talks and the other listens.',
  'fifty_point_2_1' : 'Subject',
  'fifty_headline_3' : 'Part 2: Next person talks and the first listens',
  'fifty_point_3_1' : 'Subject',
  'fifty_headline_4' : 'Summary',
  'fifty_point_4_1' : 'Share appreciation for listening and sharing with each other.',
  'fifty_point_4_2' : 'Is there anything to bring with us from this meeting',

  'rdd_description' : 'A method for problem solving where one person gets to talk (talker) and the other one listens (listener). The listener does not interrupt with their own comments or thoughts, just like a rubber duck. By doing so the talker is given an opportunity to find their own solution simply by formulating their own thoughts or challenges.',
  'rdd_headline_1' : 'Intro (5 min)',
  'rdd_point_1_1' : 'Decide who keeps track of the time, suggested - the listener',
  'rdd_point_1_2' : 'Decide where to walk, if you are walking together.',

  'rdd_headline_2' : 'Debug',
  'rdd_point_2_1' : 'Talker - Start describing your problem',
  'rdd_point_2_2' : 'Listener - Listen and keep track of the time',

  'rdd_headline_3': 'Questions to think about',
  'rdd_point_3_1' : 'What is the problem?',
  'rdd_point_3_2' : 'How do you feel about the problem?',
  'rdd_point_3_3' : 'Do you have a possible solution? ',
  'rdd_point_3_4' : 'Is there any other way the problem can be solved?',
  'rdd_point_3_5' : 'What do you need to move forward? ',

  'rdd_headline_4' : 'Summary (10 min)',
  'rdd_point_4_1' : 'The person keeping track of time makes a note when it is time to finish up',
  'rdd_point_4_2' : 'The talker summarizes their insights',
  'rdd_point_4_3' : 'Decide if a new meeting needs to be scheduled and with whom.',
  'rdd_point_4_4' : 'Thank each other for taking the time',

  'info_description' : 'A meeting where the participants are walking, while one person is responsible for moderating, sharing information and taking eventual notes. If this is a common meeting type, it is a good idea to rotate who is responsible each time.',
  'info_headline_1' : "Today's agenda",
  'info_point_1_1' : 'Subject 1',
  'info_point_1_2' : 'Subject 2',
  'info_point_1_3' : 'Subject 3',
  'info_headline_2' : 'Summary',
  'info_point_2_1' : 'Share potential notes with everyone attending',

  'stand_description' : 'A brief daily summary where everyone gets their chance to share - What they have done since the groups last stand-up, what the plan is for today and if they need help or support from anyone to move forward. The goal is to help each other reflect and summarize what has been done and what to prioritize for the day.',
  'stand_headline_1' : 'Suggestion: The person who entered the meeting last begins.',
  'stand_point_1_1' : 'What did you do yesterday?',
  'stand_point_1_2' : 'What are you planning to do today?',
  'stand_point_1_3' : 'Is there anything you need help/support with?',
  'stand_point_1_4' : 'Give the floor to a coworker',
  'stand_headline_2' : 'The next person answers the same questions and so on'

}